import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { QrCode, Loader2 } from "lucide-react";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { useAuth } from "../../context/AuthContext";
import { useToast } from "../../hooks/use-toast";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const { toast } = useToast();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      const next = new URLSearchParams(window.location.search).get("next");
      navigate(next && next.startsWith("/") ? next : u.role === "superadmin" ? "/app/admin" : "/app");
    } catch (err) {
      toast({ title: "Accesso non riuscito", description: err?.response?.data?.detail || "Riprova", variant: "destructive" });
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex flex-col justify-between p-12 bg-secondary text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-30" style={{ background: "radial-gradient(60% 70% at 30% 20%, rgba(79,86,255,0.6), transparent 60%)" }} />
        <Link to="/" className="relative flex items-center gap-2.5">
          <img src="/qora-symbol.png" alt="Qora" className="h-9 w-9 rounded-lg" />
          <span className="font-display text-xl font-extrabold">Qora</span>
        </Link>
        <div className="relative">
          <h2 className="font-display text-4xl font-extrabold leading-tight">Un'unica piattaforma per QR, pagine e menù digitali.</h2>
          <p className="mt-4 text-white/70 text-lg">Crea, personalizza e aggiorna in pochi passaggi. L'AI fa il lavoro pesante.</p>
        </div>
        <p className="relative text-white/50 text-sm">© 2025 Qora</p>
      </div>

      <div className="flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-sm">
          <Link to="/" className="lg:hidden flex items-center gap-2 mb-8">
            <img src="/qora-logo.png" alt="Qora" className="h-8 w-auto" />
          </Link>
          <h1 className="font-display text-2xl font-extrabold">Bentornato</h1>
          <p className="text-muted-foreground mt-1 mb-6">Accedi al tuo account Qora.</p>

          <div className="space-y-4">
            <div>
              <Label className="text-sm">Email</Label>
              <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="h-11 mt-1.5" placeholder="nome@azienda.it" />
            </div>
            <div>
              <Label className="text-sm">Password</Label>
              <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="h-11 mt-1.5" placeholder="••••••••" />
            </div>
          </div>
          <Button type="submit" disabled={loading} className="w-full btn-grad text-white font-semibold h-11 mt-6">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Accedi"}
          </Button>
          <p className="text-sm text-muted-foreground mt-5 text-center">
            Non hai un account? <Link to="/registrati" className="text-primary font-semibold">Registrati</Link>
          </p>
          <div className="mt-6 rounded-xl bg-muted/60 p-3 text-xs text-muted-foreground">
            <p className="font-semibold text-foreground mb-1">Demo rapida</p>
            Azienda: demo@qora.app / demo12345<br />Admin Qora: admin@qora.app / qora-admin-2025
          </div>
        </form>
      </div>
    </div>
  );
}
